export { default } from './StatusIcon.jsx';
